export * from './store-pixel.component';
